import React from 'react'
import Link from 'next/link'
import type { Article } from './index'
import { ArticleDate } from './article-date'

export const ArticleCard = ({
  title,
  categoryName,
  tags,
  postDateText,
  summary,
  url,
  mainImage,
}: Article) => (
  <article className="c-article-card">
    <Link prefetch={false} href={url} className="c-article-card__link">
      {mainImage?.url ? (
        <div className="c-article-card__image-wrap">
          <img
            className="c-article-card__image"
            src={mainImage?.url}
            role="presentation"
            alt={title || categoryName || 'article image'}
          />
        </div>
      ) : null}
      <div className="c-article-card__content">
        {categoryName && <div className="c-article-card__category">{categoryName}</div>}
        {title ? <h3 className="c-article-card__title h3">{title}</h3> : null}
        {summary ? <p className="c-article-card__description">{summary}</p> : null}
        <footer className="c-article-card__footer">
          {tags && tags.length > 0 && (
            <ul className="c-article-card__tags">
              {tags.map((tag, i) =>
                tag.name ? (
                  <li className="c-article-card__tag" key={tag.name + i}>
                    {tag.url ? (
                      <Link prefetch={false} href={tag.url}>
                        {tag.name}
                      </Link>
                    ) : (
                      <span>{tag.name}</span>
                    )}
                  </li>
                ) : null
              )}
            </ul>
          )}
          <ArticleDate isoDate={postDateText} className="c-article-card__date" />
        </footer>
      </div>
    </Link>
  </article>
)
